/* ==================================================================
   VYLOIRE-MOTION.JS — Maison Motion engine v5.9.9.
   Veil · inertia scroll (native on product/cart) · choreography ·
   cursor-tilt cards · PDP: THE ATELIER WALL · parallax + bookend ·
   transitions.
   v5.9.7: The Standard pillar titles join the sitewide 3D word
   stand-up — powers Layer 6e v2's staged micro-scenes.
   v5.9.8: the House section title (.vs3__title) joins the word
   stand-up.
   v5.9.9: FAQ accordion rows join the choreography — each question
   rises from depth with the family fold, staggered down the list
   (powers Layer 8 in vyloire.css).
   ================================================================== */
(function () {
  'use strict';
  var DOC = document, HTML = DOC.documentElement;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  (function () {
    var q = window.matchMedia('(prefers-reduced-motion: reduce)');
    var h = function (e) { REDUCED = e.matches; HTML.classList.toggle('vy-reduced', REDUCED); };
    if (q.addEventListener) { q.addEventListener('change', h); } else if (q.addListener) { q.addListener(h); }
    HTML.classList.toggle('vy-reduced', REDUCED);
  })();
  var DESIGN = !!(window.Shopify && Shopify.designMode);
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var qsa = function (s, r) { return Array.prototype.slice.call((r || DOC).querySelectorAll(s)); };
  var TPL = null;
  function tpl() {
    if (TPL === null) {
      var m = DOC.querySelector('main[data-template]');
      TPL = (m && m.dataset && m.dataset.template) ? m.dataset.template : '';
    }
    return TPL;
  }
  function instantScroll(y) {
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    catch (_) { window.scrollTo(0, y); }
  }

  /* ---------- M1 · Veil ---------- */
  var VEILED = HTML.classList.contains('vy-veil-active');
  (function () {
    var veil = DOC.getElementById('vy-veil');
    var done = function () {
      HTML.classList.remove('vy-veil-active', 'vy-veil-lift');
      if (veil && veil.parentNode) veil.parentNode.removeChild(veil);
    };
    if (VEILED && veil && !REDUCED && !DESIGN) {
      var t1 = setTimeout(function () { HTML.classList.add('vy-veil-lift'); }, 950);
      var t2 = setTimeout(done, 1650);
      var skip = function () {
        clearTimeout(t1); clearTimeout(t2); done();
        ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { window.removeEventListener(ev, skip); });
      };
      ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, skip, { passive: true }); });
      setTimeout(function () { ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { window.removeEventListener(ev, skip); }); }, 1700);
    } else if (veil) { done(); }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { done(); HTML.classList.remove('vy-leaving'); }
    });
  })();

  /* ---------- M2 · Inertia smooth scroll — native on product & cart ---------- */
  (function () {
    if (REDUCED || DESIGN || !FINE) return;
    var target = window.scrollY, current = target, raf = null, active = false;
    function maxScroll() { return Math.max(0, DOC.documentElement.scrollHeight - window.innerHeight); }
    function inNativeScroller(el) {
      var n = el, i = 0;
      while (n && n !== DOC.body && i++ < 12) {
        if (n.nodeType === 1) {
          if (n.tagName === 'TEXTAREA' || n.tagName === 'SELECT') return true;
          var s = getComputedStyle(n), oy = s.overflowY;
          if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 2) return true;
        }
        n = n.parentNode;
      }
      return false;
    }
    function loop() {
      if (REDUCED) { raf = null; active = false; return; }
      var d = target - current;
      if (Math.abs(d) < 0.4) { current = target; instantScroll(target); raf = null; active = false; return; }
      current += d * 0.16;
      instantScroll(Math.round(current));
      raf = requestAnimationFrame(loop);
    }
    window.addEventListener('wheel', function (e) {
      try {
        if (REDUCED) return;
        if (tpl() === 'product' || tpl() === 'cart') return;
        if (e.ctrlKey || e.defaultPrevented) return;
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        if (getComputedStyle(DOC.body).overflow === 'hidden') return;
        if (inNativeScroller(e.target)) return;
        e.preventDefault();
        var dy = e.deltaMode === 1 ? e.deltaY * 40 : (e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY);
        if (!active) { current = window.scrollY; target = current; }
        target = Math.max(0, Math.min(maxScroll(), target + dy));
        active = true;
        if (!raf) raf = requestAnimationFrame(loop);
      } catch (_) { }
    }, { passive: false });
    window.addEventListener('scroll', function () {
      if (!active) { current = target = window.scrollY; }
    }, { passive: true });
  })();

  /* ---------- M3 · Choreography engine ---------- */
  var plxItems = [], footMark = null;
  function arm() {
    if (DESIGN) return;
    var T = tpl();
    var vh = window.innerHeight;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(onSee, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }) : null;
    function onSee(entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('vy-in');
          io.unobserve(en.target);
          scheduleCleanup(en.target);
        }
      });
    }
    function watch(el) { if (io) { io.observe(el); } else { el.classList.add('vy-in'); } }
    function scheduleCleanup(el) {
      if (!el.classList.contains('vy-mask')) return;
      var i = parseFloat(el.style.getPropertyValue('--vy-i')) || 0;
      setTimeout(function () {
        el.classList.remove('vy-mask', 'vy-in');
        el.style.removeProperty('--vy-i');
      }, 1900 + i * 80);
    }
    function splitWords(el) {
      if (!el || el.dataset.vySplit) return;
      el.dataset.vySplit = '1';
      var hasChildEls = el.children.length > 0;
      var text = (el.textContent || '').trim();
      var words = text.split(/\s+/);
      if (hasChildEls || !text || words.length > 14) { el.classList.add('vy-clip'); watch(el); return; }
      el.setAttribute('aria-label', text);
      el.textContent = '';
      for (var i = 0; i < words.length; i++) {
        var o = DOC.createElement('span'); o.className = 'vy-w'; o.setAttribute('aria-hidden', 'true');
        var n = DOC.createElement('span'); n.className = 'vy-wi'; n.textContent = words[i];
        n.style.setProperty('--vy-wd', (i * 42) + 'ms');
        o.appendChild(n); el.appendChild(o);
        if (i < words.length - 1) el.appendChild(DOC.createTextNode(' '));
      }
      el.classList.add('vy-words'); watch(el);
    }
    var headingSel = ['.rich-text__wrapper h2', '.rich-text__wrapper .h1', '.title-wrapper-with-link .title', '.title-wrapper .title', '.collection-hero__title', '.vc3__title', '.vs3__title', '.multicolumn.color-scheme-3 .multicolumn-card__info h3', '.main-page-title', '.banner__heading', '.image-with-text__heading', '.article-template__title', '.template-search__header h1'].join(',');
    qsa(headingSel).forEach(function (el) {
      if (el.closest('.product__info-container') || el.closest('cart-drawer') || el.closest('.footer')) return;
      splitWords(el);
    });
    qsa('.main-page-title,.collection-hero--text-only .collection-hero__title').forEach(function (el) {
      el.classList.add('vy-rule'); if (!el.dataset.vySplit) watch(el);
    });
    var maskEls = [];
    qsa('.card__media').forEach(function (el) { maskEls.push(el); });
    qsa('.image-with-text__media').forEach(function (el) { maskEls.push(el); });
    var skipAboveFold = (T === 'collection' || T === 'product' || T === 'search' || T === 'article' || T === 'list-collections');
    maskEls.forEach(function (el) {
      if (el.closest('cart-drawer') || el.closest('.vy-foot-mark')) return;
      if (skipAboveFold) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) return;
      }
      var li = el.closest('li,.grid__item');
      var idx = 0;
      if (li && li.parentNode) { idx = Array.prototype.indexOf.call(li.parentNode.children, li); if (idx < 0) idx = 0; }
      el.style.setProperty('--vy-i', String(Math.min(idx % 8, 7)));
      el.classList.add('vy-mask'); watch(el);
    });
    if (T === 'index') {
      var chapters = [['featured-collection', 'The Edit'], ['shop_by_collection', 'The Collections'], ['multicolumn_trust', 'The Standard'], ['featured_blog', 'The Journal'], ['collapsible_faq', 'Questions, Answered']];
      var num = 0;
      chapters.forEach(function (c) {
        var sec = DOC.querySelector('.shopify-section[id$="__' + c[0] + '"]');
        if (!sec) return;
        var h = sec.querySelector('h2');
        if (!h) return;
        var anchor = h.closest('.title-wrapper-with-link') || h.closest('.title-wrapper') || h.closest('.collapsible-content__header') || h;
        if (!anchor.parentNode) return;
        num++;
        var d = DOC.createElement('div');
        d.className = 'vy-chapter';
        d.setAttribute('aria-hidden', 'true');
        d.innerHTML = '<span class="vy-chapter__no">0' + num + '</span><span class="vy-chapter__line"></span><span class="vy-chapter__label">' + c[1] + '</span>';
        anchor.parentNode.insertBefore(d, anchor);
        watch(d);
      });
    }
    /* ---------- EDITORIAL LAYER — pages, articles, policies ---------- */
    var POLICY = !!DOC.querySelector('.shopify-policy__container');
    if (T === 'page' || T === 'article' || T === 'policy' || POLICY) {
      if (!DOC.getElementById('vy-editorial-css')) {
        var ed = DOC.createElement('style');
        ed.id = 'vy-editorial-css';
        ed.textContent = '#MainContent .rte{font-size:1.72rem;line-height:1.92;color:rgba(28,26,24,.88);perspective:100rem}'
          + '#MainContent .rte>p:first-of-type::first-letter{font-family:var(--font-heading-family);font-size:4.4em;line-height:.76;float:left;padding:.06em .14em 0 0;color:#1c1a18}'
          + '#MainContent .rte h2{font-size:clamp(2.8rem,3.4vw,4.2rem);line-height:1.15;margin:2em 0 .7em;position:relative;padding-top:.85em}'
          + '#MainContent .rte h3{font-size:clamp(2.2rem,2.6vw,3rem);line-height:1.2;margin:1.8em 0 .55em;position:relative;padding-top:.8em}'
          + '#MainContent .rte h2:before,#MainContent .rte h3:before{content:"";position:absolute;top:0;left:0;width:4.8rem;height:1px;background:#b08a5a}'
          + 'html.vy-js:not(.vy-reduced) #MainContent .rte h2:before,html.vy-js:not(.vy-reduced) #MainContent .rte h3:before{transform:scaleX(0);transform-origin:0 50%;transition:transform 1.2s cubic-bezier(.22,1,.36,1) .3s}'
          + 'html.vy-js:not(.vy-reduced) #MainContent .rte h2.vy-in:before,html.vy-js:not(.vy-reduced) #MainContent .rte h3.vy-in:before{transform:scaleX(1)}'
          + '#MainContent .rte img{border-radius:1.6rem;box-shadow:0 2rem 5rem rgba(28,26,24,.16);will-change:transform}'
          + '#MainContent .rte blockquote{border-left:2px solid #b08a5a;margin:2em 0;padding:.4em 0 .4em 2.2rem;font-family:var(--font-heading-family);font-size:1.22em;line-height:1.6;font-style:italic;color:#1c1a18}'
          + '#MainContent .rte ul,#MainContent .rte ol{padding-left:2.2rem}'
          + '#MainContent .rte li{margin-bottom:.55em}'
          + '#MainContent .rte li::marker{color:#b08a5a}'
          + '#MainContent .rte table{font-size:.92em}'
          + '#MainContent .rte hr{border:0;height:1px;background:rgba(28,26,24,.16);margin:3em auto;max-width:22rem}'
          + '.main-page-title{margin-bottom:1em}'
          + '#MainContent .shopify-policy__container{max-width:76rem;margin:0 auto;padding:5rem 1.5rem 7rem}'
          + '#MainContent .shopify-policy__title{text-align:center;margin-bottom:3.6rem}'
          + '#MainContent .shopify-policy__title h1{font-size:clamp(2.8rem,3.2vw,4rem);letter-spacing:.02em;margin:0}'
          + '#MainContent .shopify-policy__title:after{content:"";display:block;width:4rem;height:1px;background:rgba(28,26,24,.3);margin:2.4rem auto 0}'
          + 'html.vy-js:not(.vy-reduced) #MainContent .rte .vy-rise{transform-origin:50% 100%}'
          + 'html.vy-js:not(.vy-reduced) #MainContent .rte .vy-rise:not(.vy-in){opacity:0;transform:translateY(3.8rem) rotateX(-18deg) scale(.988)}'
          + 'html.vy-js:not(.vy-reduced) #MainContent .rte .vy-rise.vy-in{opacity:1;transform:none;transition:opacity .9s ease calc(var(--vy-i,0)*90ms),transform 1.25s cubic-bezier(.19,1,.22,1) calc(var(--vy-i,0)*90ms)}';
        DOC.head.appendChild(ed);
      }
      var pTitle = DOC.querySelector('#MainContent .shopify-policy__title h1');
      if (pTitle) splitWords(pTitle);
      qsa('#MainContent .rte h2, #MainContent .rte h3').forEach(function (el) {
        if (el.closest('.footer')) return;
        splitWords(el);
      });
      /* Collect blocks — unwrap giant single-div wrappers (Shopify's generated
         Privacy policy wraps the whole document in one div) so children
         cascade individually. */
      var kids = [];
      qsa('#MainContent .rte > *').forEach(function (el) {
        if (el.tagName === 'DIV' && el.children.length > 3) {
          Array.prototype.push.apply(kids, qsa(':scope > *', el));
        } else {
          kids.push(el);
        }
      });
      kids.forEach(function (el, i) {
        if (el.dataset && el.dataset.vySplit) { el.style.setProperty('--vy-i', String(i % 6)); return; }
        /* Never arm oversized blocks — they stay permanently visible. */
        var hgt = el.getBoundingClientRect().height;
        if (hgt > vh * 0.75) return;
        el.classList.add('vy-rise'); el.style.setProperty('--vy-i', String(i % 6)); watch(el);
      });
      var rimgs = qsa('#MainContent .rte img');
      if (rimgs.length && FINE && !REDUCED) {
        var rTick = false;
        var rFrame = function () {
          rTick = false;
          if (REDUCED) return;
          var vh2 = window.innerHeight;
          for (var k = 0; k < rimgs.length; k++) {
            var rr = rimgs[k].getBoundingClientRect();
            if (rr.bottom < -60 || rr.top > vh2 + 60) continue;
            var pp = (vh2 - rr.top) / (vh2 + rr.height);
            pp = Math.max(0, Math.min(1, pp));
            rimgs[k].style.transform = 'perspective(90rem) rotateX(' + ((0.5 - pp) * 6).toFixed(2) + 'deg) translateY(' + ((pp - 0.5) * -12).toFixed(1) + 'px)';
          }
        };
        window.addEventListener('scroll', function () { if (!rTick) { rTick = true; requestAnimationFrame(rFrame); } }, { passive: true });
        requestAnimationFrame(rFrame);
      }
    }
    if (T === 'cart') {
      qsa('.cart-items .cart-item').forEach(function (el, i) {
        el.classList.add('vy-rise'); el.style.setProperty('--vy-i', String(Math.min(i, 6))); watch(el);
      });
    }
    qsa('.multicolumn-card').forEach(function (el, i) {
      var li = el.closest('li');
      var idx = li && li.parentNode ? Array.prototype.indexOf.call(li.parentNode.children, li) : i;
      el.classList.add('vy-rise'); el.style.setProperty('--vy-i', String(Math.min(idx, 5))); watch(el);
    });
    /* FAQ — questions rise from depth, staggered down the list (v5.9.9) */
    qsa('.collapsible-content .accordion').forEach(function (el, i) {
      el.classList.add('vy-rise'); el.style.setProperty('--vy-i', String(Math.min(i, 6))); watch(el);
    });
    if (FINE && !REDUCED) {
      qsa('.image-with-text__media,.article-template__hero-container').forEach(function (el) {
        var m = el.querySelector('img,video');
        if (!m) return;
        el.classList.add('vy-plx');
        plxItems.push(el);
      });
    }
    var foot = DOC.querySelector('.footer');
    if (foot && !DOC.querySelector('.vy-foot-mark')) {
      footMark = DOC.createElement('div');
      footMark.className = 'vy-foot-mark';
      footMark.setAttribute('aria-hidden', 'true');
      footMark.textContent = 'Vyloire';
      foot.insertBefore(footMark, foot.firstChild);
    }
    /* ---------- THE FINALE — 3D footer scene, sitewide ---------- */
    if (foot) {
      if (!DOC.getElementById('vy-footer-css')) {
        var fcss = DOC.createElement('style');
        fcss.id = 'vy-footer-css';
        fcss.textContent = '.footer{perspective:110rem}'
          + '.footer .footer__content-top,.footer .footer__content-bottom{will-change:transform;transform-origin:50% 100%}'
          + 'html.vy-js:not(.vy-reduced) .footer .vy-rise-f{transform-origin:50% 100%}'
          + 'html.vy-js:not(.vy-reduced) .footer .vy-rise-f:not(.vy-in){opacity:0;transform:translateY(3.4rem) rotateX(-15deg)}'
          + 'html.vy-js:not(.vy-reduced) .footer .vy-rise-f.vy-in{opacity:1;transform:none;transition:opacity .85s ease calc(var(--vy-i,0)*120ms),transform 1.05s cubic-bezier(.22,1,.36,1) calc(var(--vy-i,0)*120ms)}';
        DOC.head.appendChild(fcss);
      }
      qsa('.footer .footer-block').forEach(function (el, i) {
        el.classList.add('vy-rise-f');
        el.style.setProperty('--vy-i', String(i % 6));
        watch(el);
      });
      var fTop = foot.querySelector('.footer__content-top');
      var fBot = foot.querySelector('.footer__content-bottom');
      if ((fTop || fBot) && FINE && !REDUCED) {
        var fTick = false;
        var fFrame = function () {
          fTick = false;
          if (REDUCED) return;
          var vh3 = window.innerHeight;
          var fr = foot.getBoundingClientRect();
          if (fr.top > vh3 + 120) return;
          var fp = Math.max(0, Math.min(1, (vh3 - fr.top) / Math.min(vh3, fr.height + 1)));
          if (fTop) fTop.style.transform = 'perspective(110rem) translateY(' + ((1 - fp) * 30).toFixed(1) + 'px) rotateX(' + ((1 - fp) * 4).toFixed(2) + 'deg)';
          if (fBot) fBot.style.transform = 'translateY(' + ((1 - fp) * 16).toFixed(1) + 'px)';
        };
        window.addEventListener('scroll', function () { if (!fTick) { fTick = true; requestAnimationFrame(fFrame); } }, { passive: true });
        requestAnimationFrame(fFrame);
      }
    }
    HTML.classList.add('vy-armed');
    qsa('.vy-words,.vy-clip,.vy-mask,.vy-rise,.vy-rise-f,.vy-chapter,.vy-rule').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.96 && r.bottom > 0) {
        el.classList.add('vy-in');
        if (io) io.unobserve(el);
        scheduleCleanup(el);
      }
    });
    setTimeout(function () {
      qsa('.vy-mask:not(.vy-in),.vy-words:not(.vy-in),.vy-clip:not(.vy-in),.vy-rise:not(.vy-in),.vy-rise-f:not(.vy-in),.vy-chapter:not(.vy-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('vy-in');
      });
    }, 6000);
  }

  /* ---------- M3b · Cursor-tilt plates: cards ---------- */
  (function () {
    if (REDUCED || DESIGN || !FINE) return;
    var SEL = '.card, .multicolumn-card';
    var raf = null, pending = null;
    DOC.addEventListener('pointermove', function (e) {
      if (REDUCED) return;
      var card = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!card) return;
      pending = { el: card, x: e.clientX, y: e.clientY };
      if (!raf) raf = requestAnimationFrame(apply);
    }, { passive: true });
    function apply() {
      raf = null;
      if (!pending) return;
      var el = pending.el, r = el.getBoundingClientRect();
      var nx = (pending.x - r.left) / r.width - 0.5;
      var ny = (pending.y - r.top) / r.height - 0.5;
      el.classList.add('vy-tilting');
      el.style.setProperty('--vy-ry', (nx * 6).toFixed(2) + 'deg');
      el.style.setProperty('--vy-rx', (ny * -5).toFixed(2) + 'deg');
      pending = null;
    }
    DOC.addEventListener('pointerout', function (e) {
      var card = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      card.classList.remove('vy-tilting');
      card.style.removeProperty('--vy-ry');
      card.style.removeProperty('--vy-rx');
    }, { passive: true });
  })();

  /* ---------- M4 · Parallax + bookend ---------- */
  (function () {
    if (REDUCED || DESIGN) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (REDUCED) return;
      var vh = window.innerHeight;
      for (var i = 0; i < plxItems.length; i++) {
        var el = plxItems[i], r = el.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) continue;
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        if (p > 1) p = 1; else if (p < -1) p = -1;
        el.style.setProperty('--vy-p', (-p).toFixed(4));
      }
      if (footMark) {
        var fr = footMark.getBoundingClientRect();
        var fp = 1 - fr.top / vh;
        if (fp < 0) fp = 0; else if (fp > 1) fp = 1;
        footMark.style.setProperty('--vy-fm', fp.toFixed(3));
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setTimeout(update, 100);
    setInterval(function () { if (plxItems.length || footMark) update(); }, 900);
  })();

  /* ---------- M5 · Page-leave transitions ---------- */
  (function () {
    if (REDUCED || DESIGN || !FINE) return;
    DOC.addEventListener('click', function (e) {
      if (REDUCED) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-vy-instant')) return;
      var url;
      try { url = new URL(a.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.hash) return;
      if (/\/(cart|checkout|account|challenge)/.test(url.pathname)) return;
      if (a.closest('cart-drawer,form,.shopify-payment-button,.cart,.quick-add')) return;
      e.preventDefault();
      HTML.classList.add('vy-leaving');
      setTimeout(function () { location.href = a.href; }, 210);
    }, true);
  })();

  /* ---------- M6 · Scroll instrument ---------- */
  (function () {
    if (REDUCED || DESIGN) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;
    var el = DOC.createElement('div');
    el.className = 'vy-progress';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="vy-progress__bar"></div><div class="vy-progress__num">000</div>';
    var num;
    function mount() { if (DOC.body) { DOC.body.appendChild(el); num = el.querySelector('.vy-progress__num'); setTimeout(upd, 150); } }
    var ticking = false;
    function upd() {
      ticking = false;
      if (REDUCED || !num) return;
      var max = Math.max(1, DOC.documentElement.scrollHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, window.scrollY / max));
      el.style.setProperty('--vy-sp', p.toFixed(4));
      var n = Math.round(p * 100);
      num.textContent = (n < 10 ? '00' : n < 100 ? '0' : '') + n;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    if (DOC.readyState === 'loading') { DOC.addEventListener('DOMContentLoaded', mount); } else { mount(); }
  })();

  /* ---------- M7 · THE ATELIER WALL — first 8 pieces, cinematic hang-and-lift handoff ---------- */
  (function () {
    if (REDUCED || DESIGN || !FINE) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;
    function init() {
      if (tpl() !== 'product') return;
      var ul = DOC.querySelector('.product__media-list');
      if (!ul || ul.classList.contains('vy-wall') || ul.classList.contains('vy-proc') || ul.classList.contains('vy-view') || ul.classList.contains('vy-walk') || ul.classList.contains('vy-ring')) return;
      var all = qsa('.product__media-item', ul);
      if (all.length < 2) return;
      var items = all.slice(0, 8);
      all.slice(8).forEach(function (it) { it.style.display = 'none'; });
      var n = items.length;
      var stage = ul.parentElement;
      var gallery = stage ? stage.parentElement : null;
      var mw = gallery ? gallery.parentElement : null;
      var infoEl = DOC.querySelector('.product__info-container') || DOC.querySelector('.product__info-wrapper');
      var RATIO = 0;
      var pimg = items[0].querySelector('.media img') || items[0].querySelector('img');
      function computeRatio() {
        if (pimg && pimg.naturalWidth > 0) {
          var r = pimg.naturalHeight / pimg.naturalWidth;
          if (r > 0.3 && r < 2.6) RATIO = r;
        }
      }
      computeRatio();
      if (!DOC.getElementById('vy-wall-css')) {
        var css = '.vy-wall-stage{position:relative;perspective:1500px;perspective-origin:50% 46%;overflow:hidden;outline:none;'
          + '-webkit-mask-image:linear-gradient(180deg,transparent 0,#000 5%,#000 95%,transparent 100%);'
          + 'mask-image:linear-gradient(180deg,transparent 0,#000 5%,#000 95%,transparent 100%)}'
          + '.vy-wall{position:relative;width:100%;height:100%;transform-style:preserve-3d;margin:0;padding:0;list-style:none;display:block}'
          + '.vy-wall .product__media-item{position:absolute;top:50%;left:50%;margin:0;width:var(--vy-iw,560px)!important;max-width:none!important;min-width:0!important;backface-visibility:hidden;will-change:transform,opacity;cursor:grab}'
          + '.vy-wall .product__media-item:active{cursor:grabbing}'
          + '.vy-wall .product__media-item .media{position:relative;padding:0!important;height:var(--vy-mh,480px);box-shadow:0 30px 72px rgba(28,26,24,.36);border:7px solid #f8f4ee;background:#f8f4ee}'
          + '.vy-wall .product__media-item .media img,.vy-wall .product__media-item .media>*{position:absolute!important;inset:0;width:100%!important;height:100%!important;object-fit:contain!important}'
          + '.vy-wall-hint{position:absolute;left:0;right:0;bottom:8px;text-align:center;letter-spacing:.18em;text-transform:uppercase;font-size:1rem;opacity:.5;margin:0;pointer-events:none;z-index:200}'
          + 'html.vy-reduced .vy-wall .product__media-item{will-change:auto}';
        var stl = DOC.createElement('style');
        stl.id = 'vy-wall-css';
        stl.textContent = css;
        DOC.head.appendChild(stl);
      }
      ul.classList.add('vy-wall');
      if (stage) {
        stage.classList.add('vy-wall-stage');
        stage.setAttribute('tabindex', '0');
        stage.setAttribute('role', 'group');
        stage.setAttribute('aria-roledescription', 'scrolling gallery wall');
        stage.setAttribute('aria-label', 'Product gallery. Scroll the page to walk past each image; drag the gallery or use the arrow keys to browse.');
      }
      var colW = 800, stageH = 640, VSPAN = 560, W = 560;
      var runway = 1800, stickPx = 33;
      function size() {
        colW = stage ? stage.clientWidth : 800;
        stageH = Math.max(520, Math.min(720, Math.round(colW * 0.82)));
        if (stage) stage.style.height = stageH + 'px';
        VSPAN = Math.round(stageH * 0.92);
        var r0 = RATIO || 1.25;
        W = Math.round(Math.min(colW * 0.9, (stageH - 44) / r0));
        var H = Math.round(W * r0);
        items.forEach(function (it) {
          it._vyW = W;
          it.style.setProperty('--vy-iw', W + 'px');
          it.style.setProperty('--vy-mh', H + 'px');
        });
        var st = gallery ? parseFloat(getComputedStyle(gallery).top) : NaN;
        if (!(st >= 0)) st = 33;
        stickPx = Math.round(st);
        runway = Math.min((n - 1) * 260, 4800);
        var galH = gallery ? gallery.getBoundingClientRect().height : stageH;
        if (mw) mw.style.setProperty('min-height', Math.round(galH + runway) + 'px', 'important');
        if (infoEl) {
          infoEl.style.position = 'sticky';
          infoEl.style.top = stickPx + 'px';
        }
      }
      size();
      setTimeout(size, 700);
      if (!RATIO && pimg) {
        pimg.addEventListener('load', function () { computeRatio(); if (RATIO) size(); }, { once: true });
        var tries = 0;
        var iv = setInterval(function () {
          computeRatio();
          if (RATIO || ++tries > 10) { clearInterval(iv); if (RATIO) size(); }
        }, 300);
      }
      var szT = null;
      window.addEventListener('resize', function () {
        size();
        clearTimeout(szT);
        szT = setTimeout(size, 200);
      }, { passive: true });
      var hint = DOC.createElement('p');
      hint.className = 'vy-wall-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.textContent = 'Scroll to walk the wall · Click a piece to zoom';
      if (stage) stage.appendChild(hint);
      /* ------- engine ------- */
      var t = 0, autoT = 0, vel = 0;
      var dragging = false, dragged = false, lastPX = 0, lastPY = 0, hover = false, ioVisible = true, raf = null;
      var lastInteract = performance.now(), lastScrollY = window.scrollY, lastScrollAt = 0;
      function start() { if (!raf) raf = requestAnimationFrame(frame); }
      function frame(now) {
        raf = null;
        if (REDUCED) return;
        var mwTop = mw ? mw.getBoundingClientRect().top : 0;
        var pin = Math.max(0, Math.min(stickPx - mwTop, runway));
        var inRange = mwTop < window.innerHeight + 600 && pin < runway + 1;
        if (!ioVisible && !inRange) return;
        var sy = window.scrollY;
        if (Math.abs(sy - lastScrollY) > 1) { lastScrollY = sy; lastInteract = now; lastScrollAt = now; }
        if (!dragging) {
          if (Math.abs(vel) > 0.0004) {
            autoT += vel;
            vel *= 0.92;
            lastInteract = now;
          } else {
            vel = 0;
            if (now - lastScrollAt < 450 && Math.abs(autoT) > 0.002) autoT *= 0.965;
            if (!hover && now - lastInteract > 6000) {
              if ((pin / runway) * (n - 1) + autoT < n - 1 - 0.02) autoT += 0.0016;
            }
          }
        }
        var goal = Math.max(0, Math.min(n - 1, (pin / runway) * (n - 1) + autoT));
        t += (goal - t) * 0.09;
        if (Math.abs(goal - t) < 0.0008) t = goal;
        var sway = Math.sin(now * 0.0006) * 1.6;
        var bob = Math.sin(now * 0.00045) * 3;
        for (var i = 0; i < n; i++) {
          var it = items[i];
          var u = i - t;
          var au = Math.abs(u);
          var st = it.style;
          if (au > 1.5) { if (st.visibility !== 'hidden') st.visibility = 'hidden'; continue; }
          if (st.visibility === 'hidden') st.visibility = '';
          var w = Math.max(0, 1 - au);
          var y = u * VSPAN + bob * w;
          var x = u * 66;
          var z = -au * 360;
          var rx = u * -17;
          var ry = u * -7 + sway * w;
          var rz = u * 2.8;
          var sc = 1 - au * 0.1;
          st.transform = 'translate3d(' + (x - it._vyW / 2).toFixed(1) + 'px, calc(-50% + ' + y.toFixed(1) + 'px), ' + z.toFixed(0) + 'px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
          st.zIndex = String(100 - Math.round(au * 20));
          st.opacity = (1 - Math.min(au * 0.95, 0.9)).toFixed(3);
          st.filter = 'brightness(' + (1 - Math.min(au * 0.5, 0.5)).toFixed(3) + ')';
        }
        raf = requestAnimationFrame(frame);
      }
      window.addEventListener('scroll', function () { start(); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          ioVisible = en[0].isIntersecting;
          if (ioVisible) { lastInteract = performance.now(); start(); }
        }, { threshold: 0 }).observe(ul);
      }
      if (stage) {
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { autoT += 1; lastInteract = performance.now(); e.preventDefault(); start(); }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { autoT -= 1; lastInteract = performance.now(); e.preventDefault(); start(); }
        });
      }
      ul.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        dragging = true; dragged = false; lastPX = e.clientX; lastPY = e.clientY; vel = 0;
        lastInteract = performance.now();
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lastPX, dy = e.clientY - lastPY;
        if (Math.abs(dx) + Math.abs(dy) > 4) dragged = true;
        var d = (dy + dx * 0.5) / VSPAN;
        autoT -= d;
        vel = -d * 0.5;
        lastPX = e.clientX; lastPY = e.clientY;
        lastInteract = performance.now();
        start();
      }, { passive: true });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        lastInteract = performance.now();
        setTimeout(function () { dragged = false; }, 60);
      }, { passive: true });
      ul.addEventListener('click', function (e) {
        if (dragged) { e.stopPropagation(); e.preventDefault(); return; }
        var li = e.target && e.target.closest ? e.target.closest('.product__media-item') : null;
        if (!li) return;
        var idx = items.indexOf(li);
        if (idx < 0) return;
        var u = idx - t;
        if (Math.abs(u) > 0.35) {
          e.stopPropagation();
          e.preventDefault();
          autoT += Math.round(u);
          lastInteract = performance.now();
          start();
        }
      }, true);
      ul.addEventListener('pointerenter', function () { hover = true; }, { passive: true });
      ul.addEventListener('pointerleave', function () { hover = false; lastInteract = performance.now(); }, { passive: true });
      DOC.addEventListener('visibilitychange', function () { if (!DOC.hidden) { lastInteract = performance.now(); start(); } });
      start();
    }
    if (DOC.readyState === 'loading') { DOC.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  /* ---------- boot ---------- */
  var armDelay = (VEILED && !REDUCED && !DESIGN) ? 900 : 0;
  function boot() { setTimeout(arm, armDelay); }
  if (DOC.readyState === 'loading') { DOC.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
